import { render } from "./TheMobilityContainer.vue?vue&type=template&id=c23bbfe6"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__